import { Component, Inject, HostListener, Input, forwardRef, OnInit, ElementRef } from '@angular/core';
import { CardComponent } from './app.card.component';
import { Card } from './card';
import { Services } from '../app.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

declare var moment: any;

declare var $: any;
@Component({
  selector: 'app-card-modal-placeholder',
  templateUrl: './app.card.modal.component.html'
})

export class CardModalComponent implements OnInit {

  @Input() card;
  @Input() selectedListDate;
  @Input() selectedTab;



  element = null;

  Var = {
    tab: null,
    selectedDay: null,
    datesHaveError: false,
    days: [],
    hasEndTime: false,
    hasStartTime: false,
    monthes: [],
    years: [],
    daysOfMonth: [],
    monthesOfYear: [{
      id: 1,
      title: 'فروردین',
      days: 31
    }, {
      id: 2,
      title: 'اردیبهشت',
      days: 31
    }, {
      id: 3,
      title: 'خرداد',
      days: 31
    }, {
      id: 4,
      title: 'تیر',
      days: 31
    }, {
      id: 5,
      title: 'مرداد',
      days: 31
    }, {
      id: 6,
      title: 'شهریور',
      days: 31
    }, {
      id: 7,
      title: 'مهر',
      days: 30
    }, {
      id: 8,
      title: 'آبان',
      days: 30
    }, {
      id: 9,
      title: 'آذر',
      days: 30
    }, {
      id: 10,
      title: 'دی',
      days: 30
    }, {
      id: 11,
      title: 'بهمن',
      days: 30
    }, {
      id: 12,
      title: 'اسفند',
      days: 30
    }]

  };
  Card = null;
  repeatText = '';
  constructor(public toastr: ToastsManager, private services: Services,
    @Inject(forwardRef(() => CardComponent)) private cardCom: CardComponent, private el: ElementRef) {
    this.element = $(el.nativeElement);

  }

  changeMonth(event) {
    this.Var.days = [];
    for (let i = 1; i <= this.Var.monthesOfYear[this.Card.Month - 1].days; i++) {
      this.Var.days.push(i);
    }
  }
  onTabClick(tab) {
    this.Var.tab = tab;
  }
  onSelectedDayClick(day) {
    this.Var.selectedDay = day;
    this.Card.FrequencyTypeID = 5;
    const today = this.getCurrentDay();
    if (day === 'tomorrow') {
      today.jDate(today.jDate() + 1);
    }
    if (day === 'datommarow') {
      today.jDate(today.jDate() + 2);
    } if (day === 'nextWeek') {
      today.jDate(today.jDate() + 7);
    }

    this.Card.Day = today.jDate();
    this.Card.Month = today.jMonth() + 1;
    this.Card.Year = today.jYear();

  }
  onRepeatTypeClick(type) {
    this.Var.selectedDay = null;
    this.Card.FrequencyTypeID = type;
  }

  onWeekDayClick(day) {
    this.Card[day] = !this.Card[day];
  }

  changeTimeMode(mode) {
    if (mode) {
      this.Card.Hour = new Date().getHours() % 12;
      this.Card.Minute = Math.floor(new Date().getMinutes() / 5) * 5;
      if (new Date().getHours() > 12) { this.Card.TimeMode = 'PM' } else {
        this.Card.TimeMode = 'AM'
      }

    }
    this.Card.HasTime = mode
  }


  onSaveClick() {

    if (!this.Card.Text) {
      this.Var.tab = 'card';
      this.toastr.warning('متن کارت را وارد نمایید', 'هشدار ');
    } else if (this.Var.datesHaveError) {

      this.toastr.warning('تاریخ های شروع و پایان را اصلاح نمایید', 'هشدار ');
    } else if (this.Card.FrequencyTypeID === 2) {


      if (!this.Card.Sat && !this.Card.Sun && !this.Card.Mon && !this.Card.Tue && !this.Card.Wed
        && !this.Card.Thu && !this.Card.Fri) {
        this.toastr.warning('هیچ روزی از هفته انتخاب نشده است.', 'هشدار ');
      } else {
        this.cardCom.cardActionFinished(this.Card);
      }

    } else {

      this.cardCom.cardActionFinished(this.Card);
    }




  }


  checkDatesValidation() {

    this.Var.datesHaveError = false;
    if (this.Card.StartDay && this.Card.StartMonth && this.Card.StartYear
      && this.Card.EndDay && this.Card.EndMonth && this.Card.EndYear) {

      if (this.Card.StartYear > this.Card.EndYear) {

        this.Var.datesHaveError = true;
      } else if (this.Card.StartYear === this.Card.EndYear && (this.Card.StartMonth !== this.Card.EndMonth)) {
        if (this.Card.StartMonth > this.Card.EndMonth) {

          this.Var.datesHaveError = true;
        }
      } else if (this.Card.StartYear === this.Card.EndYear && (this.Card.StartMonth === this.Card.EndMonth)) {

        if (this.Card.StartDay > this.Card.EndDay) {

          this.Var.datesHaveError = true;
        }
      }
    }

  }


  closeThisDialog(formCreds): void {
    this.cardCom.closeCardModal();
  }

  getCurrentDay() {
    const m = moment();
    return m;
  }


  ngOnInit() {
    if (this.card) {
      this.Card = new Card();
      this.Card = Object.assign(this.Card, this.card);


    } else {
      this.Card = new Card();
      this.onHasStartDateClick(true);
    }

    if (this.selectedListDate) {
      this.Card.Day = this.selectedListDate.Day;
      this.Card.Month = this.selectedListDate.Month;
      this.Card.Year = this.selectedListDate.Year;
    }

    const parent = this.cardCom;


    const today = this.getCurrentDay();


    // this.Card.DayStart = today.jDate();
    // this.Card.MonthStart = today.jMonth() + 1;
    // this.Card.YearStart = today.jYear();
    // this.Card.DayEnd = today.jDate();
    // this.Card.MonthEnd = today.jMonth() + 1;
    // this.Card.YearEnd = today.jYear();

    this.Var.tab = this.selectedTab ? this.selectedTab : 'card';
    // this.Card.repeatType = 'day';

    // if (this.card) {
    //   for (let i = 1; i <= this.Var.monthesOfYear[this.card.Month - 1].days; i++) {
    //     this.Var.days.push(i);
    //   }
    //   this.Card = this.card;
    //   for (let i = this.card.Year - 5; i <= this.card.Year + 5; i++) {
    //     this.Var.years.push(i);
    //   }
    // } else {


    if (!this.Card.Month) {
      this.Card.Month = this.getCurrentDay().jMonth() + 1;
    }
    for (let i = 1; i <= this.Var.monthesOfYear[this.Card.Month - 1].days; i++) {
      this.Var.days.push(i);
    }


    if (!this.Card.Year) {
      this.Card.Year = this.getCurrentDay().jYear();
    }
    for (let i = (this.Card.Year - 2); i <= (this.Card.Year + 10); i++) {
      this.Var.years.push(i);
    }
    if (!this.Card.Day) {
      this.Card.Day = this.getCurrentDay().jDate();
    }
    for (let i = 1; i <= 31; i++) {
      this.Var.daysOfMonth.push(i);
    }

    if (this.Card.StartYear) {
      this.Var.hasStartTime = true;
    }
    if (this.Card.EndYear) {
      this.Var.hasEndTime = true;
    }
    //   this.Card.Day = today.jDate();
    //   this.Card.Month = today.jMonth() + 1;
    //   this.Card.Year = today.jYear();
    // }
  }


  onHasStartDateClick(x) {
    this.Var.hasStartTime = x;

    if (x === true) {

      const today = this.getCurrentDay();
      this.Card.StartDay = today.jDate();
      this.Card.StartMonth = today.jMonth() + 1;
      this.Card.StartYear = today.jYear();

    } else {
      this.Var.hasEndTime = false;
      this.Card.StartDay = null;
      this.Card.StartMonth = null;
      this.Card.StartYear = null;
      this.Card.StartDate = null;
      this.Card.EndDate = null;
      this.Card.EndDay = null;
      this.Card.EndMonth = null;
      this.Card.EndYear = null;

    }
  }

  onHasEndDateClick(x) {
    this.Var.hasEndTime = x;
    if (x === true) {

      const today = this.getCurrentDay();
      today.jYear(today.jYear() + 1);
      this.Card.EndDay = today.jDate();
      this.Card.EndMonth = today.jMonth() + 1;
      this.Card.EndYear = today.jYear();
    } else {
      this.Card.EndDate = null;
      this.Card.EndDay = null;
      this.Card.EndMonth = null;
      this.Card.EndYear = null;
    }
  }

  generateTime() {
    let time = '';
    time += this.Card.Hour + ':';
    if (this.Card.Minute < 10) {
      time += '0' + this.Card.Minute;
    } else {
      time += this.Card.Minute;
    }

    return time;
  }


  generateTimeT(mode) {
    if (mode === 'AM') {
      return ' ق.ظ. '

    } else {
      return ' ب.ظ. '
    }
  }

  dayGapConvertor(input) {
    if (input === 0) {
      return 'هر روز';
    } else { return input + ' روز در میان'; }


  }

  weekGapConvertor(input) {
    if (input === 0) {
      return 'هر هفته';
    } else { return 'هر ' + input + '  هفته در میان'; }


  }

  monthGapConvertor(input) {
    if (input === 0) {
      return 'هر ماه';
    } else { return 'هر ' + input + '  ماه در میان'; }


  }
  yearGapConvertor(input) {
    if (input === 0) {
      return 'هر سال';
    } else { return 'هر ' + input + '  سال در میان'; }


  }


  generateRepeatText() {

    const weekDays = {
      Sat: 'ش',
      Sun: 'ی',
      Mon: 'د',
      Tue: 'س',
      Wed: 'چ',
      Thu: 'پ',
      Fri: 'ج'
    }
    this.repeatText = '';
    switch (this.Card.FrequencyTypeID) {

      case (5):
        this.repeatText = this.Card.Day + ' ام ' + this.Var.monthesOfYear[this.Card.Month - 1].title + ' ماه '
          + this.Card.Year;
        if (this.Card['HasTime']) {
          this.repeatText += ' - ' + this.generateTime() + this.generateTimeT(this.Card.TimeMode);
        } break;
      case (1):

        this.repeatText = this.dayGapConvertor(this.Card.GapAmount);

        if (this.Card['HasTime']) {
          this.repeatText += ' - ' + this.generateTime() + this.generateTimeT(this.Card.TimeMode);
        } break;
      case (2):
        // tslint:disable-next-line:prefer-const
        for (let day in weekDays) {

          if (this.Card[day]) {
            this.repeatText += (weekDays[day] + ' ');
          }
        }
        this.repeatText += this.weekGapConvertor(this.Card.GapAmount);

        if (this.Card['HasTime']) {
          this.repeatText += ' - ' + this.generateTime() + this.generateTimeT(this.Card.TimeMode);
        }

        break;
      case (3):

        this.repeatText = this.Card.Day + ' ام '
        this.repeatText += this.monthGapConvertor(this.Card.GapAmount);

        if (this.Card['HasTime']) {
          this.repeatText += ' - ' + this.generateTime() + this.generateTimeT(this.Card.TimeMode);
        }
        break;
      case (4):
        this.repeatText = this.Card.Day + ' ام ' + this.Var.monthesOfYear[this.Card.Month - 1].title + ' ماه ';
        this.repeatText += this.yearGapConvertor(this.Card.GapAmount);

        if (this.Card['HasTime']) {
          this.repeatText += ' - ' + this.generateTime() + this.generateTimeT(this.Card.TimeMode);
        }
        break;
    }


    return this.repeatText;
  }




  @HostListener('document:keydown', ['$event']) onEnterKeyDown(e) {
    if (e.shiftKey && e.keyCode === 13) {
      e.stopPropagation()
      e.preventDefault();


      this.onSaveClick();


    }
  }
  @HostListener('keydown', ['$event']) onKeyDown(e) {
    if (e.shiftKey && e.keyCode === 78) {

      e.stopPropagation()
    } else if (e.shiftKey && e.keyCode === 83) {
      e.stopPropagation()
    }




  }


}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/card/app.card.modal.component.ts